var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.interessado.espolio != null
        ? _c("app-display", {
            class:
              _vm.compararInteressado &&
              _vm.compararInteressado.mudouEspolioInteressados
                ? "text"
                : "",
            attrs: {
              label: "É espólio:",
              content: _vm.interessado.espolio ? "Sim" : "Não"
            }
          })
        : _vm._e(),
      _c("informacoes-pessoa", {
        attrs: {
          pessoa: _vm.interessado.pessoa,
          compararInformacoesPessoa:
            _vm.compararInteressado && _vm.compararInteressado.mudouPessoa
        }
      }),
      _vm.interessado.socios && _vm.interessado.socios.length > 0
        ? _c(
            "app-collapse",
            { attrs: { title: "Sócios" } },
            _vm._l(_vm.interessado.socios, function(socio, index) {
              return _c(
                "app-collapse",
                { key: socio.cpf, attrs: { title: socio.pessoaFisica.nome } },
                [
                  _c("informacoes-pessoa", {
                    attrs: {
                      pessoa: socio,
                      isSocioRepresentanteLegal: true,
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal,
                      compararIsSocioRepresentanteLegal:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal
                    }
                  }),
                  socio.documentos && socio.documentos.length > 0
                    ? _c("listagem-documentos", {
                        attrs: {
                          documentos: socio.documentos,
                          idSocio: socio.id,
                          idCadastro: _vm.idCadastro,
                          ownerDocumento: "socio",
                          compararDocumentos:
                            _vm.compararInteressado &&
                            _vm.compararInteressado.mudouDocumentosInteressado,
                          versaoCadastro: _vm.versaoCadastro
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "app-divider",
        { attrs: { label: "Endereço" } },
        [
          _c("informacoes-endereco", {
            staticClass: "margin-top",
            attrs: {
              slot: "body",
              endereco: _vm.enderecoInteressado,
              mudouEndereco:
                _vm.compararInteressado && _vm.compararInteressado.mudouEndereco
            },
            slot: "body"
          })
        ],
        1
      ),
      _vm.hasConjuge
        ? _c(
            "app-divider",
            { attrs: { label: "Cônjuge" } },
            [
              !_vm.isViuvo
                ? _c("informacoes-pessoa", {
                    staticClass: "margin-top",
                    attrs: {
                      slot: "body",
                      pessoa: _vm.interessado.conjuge,
                      isConjuge: _vm.hasConjuge,
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouConjugeInteressado
                    },
                    slot: "body"
                  })
                : _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa
                            .mudouTemCertidaoObito
                            ? "text"
                            : "",
                        attrs: {
                          label: "Possui certidão de óbito?",
                          content: _vm.interessado.conjuge.pessoaFisica
                            .temCertidaoObito
                            ? "Sim"
                            : "Não"
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouCPF
                            ? "text"
                            : "",
                        attrs: {
                          label: "CPF:",
                          content: _vm.interessado.conjuge.pessoaFisica.cpf
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouNome
                            ? "text"
                            : "",
                        attrs: {
                          label: "Nome:",
                          content: _vm.interessado.conjuge.pessoaFisica.nome
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30430bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30430bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado.vue
// module id = null
// module chunks = 